<template>
<div>
    <div class="form-container ou-donation-form ja-ou-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
            <div class="subscribe__btn" :class="{ checked: jaSift }" @click="setValue('custom.isGift', !jaSift)">
            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 123.45 115.76" style="fill: white;">
  <path d="M5.27,60.33c1.77-.73,11.2-1.54,15.02-1.12.73.08,1.48.12,2.24.12h0c1.36.03,2.69-.07,3.85-.29,2.06-.39,3.27-1.1,3.5-2.06.12-.51.02-.98-.3-1.4-1.35-1.79-6.37-2.08-6.59-2.09-14.75-.43-20.32-.23-22.19,1.72C0,56.06-.05,57.21.02,58.23c.07.93.48,1.66,1.18,2.09.53.33,1.19.46,1.86.46.77,0,1.56-.18,2.2-.45Z"/>
  <path d="M7.99,67.56h0c.89-.54,4.1-.99,7.5-1.48,2.51-.36,5.11-.73,7.22-1.18.92-.19,1.69-.4,2.31-.61,1.04-.35,1.63-.7,1.88-1.12.23-.37.27-.74.12-1.09-.33-.77-1.61-1.39-3.81-1.85-.48-.1-1-.2-1.6-.28-.44-.06-.72-.09-.72-.09-.59-.07-14.45-1.74-17.73,3.03-1.55,2.25-1.1,3.56-.45,4.25.65.7,1.76,1.01,2.85,1.01.9,0,1.79-.21,2.43-.59Z"/>
  <path d="M4.07,53.09c.64,0,1.25-.11,1.75-.32.96-.42,4.22-.47,7.66-.52,6.23-.09,10.72-.25,11.66-1.43.36-.45.33-.87.23-1.13-.58-1.68-5.26-2.8-5.79-2.92-.57-.15-14.1-3.56-17.97.76-1.82,2.04-1.54,3.39-.98,4.16.69.95,2.11,1.41,3.43,1.41Z"/>
  <path d="M22.9,68.64c.19-.45.06-.78-.07-.98-.78-1.14-4.21-1.09-4.59-1.08-.43,0-10.51.05-12.44,4.06-1.01,2.1-.33,3.06.17,3.45.42.33,1,.47,1.58.47.82,0,1.68-.28,2.22-.73.58-.49,2.84-1.15,5.23-1.85,4.33-1.27,7.44-2.25,7.89-3.35Z"/>
  <path d="M106.98,88.55c0,.26-.16.51-.4.62l-42.72,20.27v-33.15s.08-.03.12-.04l33.13-11.46-.47-.27c-.41-.24-.71-.52-.91-.85-.41-.67-.45-1.4-.12-2.05.14-.28.35-.54.62-.76l1.06-.88-32.32,11.17-1.11.38v-22.78c.48.92.98,1.74,1.52,2.5,2.55,3.56,6.11,5.69,9.83,5.84.9,0,1.71-.47,2.06-1.22.34-.74.31-1.54-.09-2.2-.39-.64-1.08-1.05-1.83-1.08-2.25-.09-4.6-1.57-6.31-3.96-1.65-2.31-2.65-5.26-3.45-7.68l40.44-15.55c.32-.13.56,0,.65.07.09.06.3.24.3.57v17.81h5.17v-17.81c0-1.94-.95-3.75-2.55-4.84-1.31-.9-2.95-1.23-4.54-.9l-8.45,3.08c3.43-2.28,7.07-5.55,7.48-10,.41-4.44-2.48-8.66-5.52-10.88-2.29-1.67-5.07-2.52-8.29-2.52-6.49,0-13.04,3.45-16.67,6.4-5.34,4.35-7.43,9.69-9.1,13.99-.93,2.4-1.66,4.89-2.17,7.44-.51-2.55-1.24-5.05-2.17-7.44-1.67-4.3-3.75-9.65-9.1-13.99C47.51,3.49,41.09.09,34.68,0h-.5s0,0,0,0c-3.11.04-5.81.89-8.04,2.51-3.04,2.22-5.92,6.45-5.52,10.88.45,4.85,4.59,8.34,9.21,11.1l-11.49-4.19c-1.55-.33-3.2,0-4.5.91-1.6,1.08-2.55,2.89-2.55,4.84v17.81h5.17v-17.81c0-.34.21-.51.31-.58.08-.06.32-.2.64-.07l38.06,14.64,1.62.63c-.26.8-.53,1.6-.82,2.41-.87,2.43-1.71,4.15-2.72,5.57-1.69,2.36-4.04,3.85-6.27,3.96-.98.05-1.82.66-2.09,1.53-.22.72-.1,1.47.33,2.06.42.57,1.1.92,1.81.92h.1c3.67-.16,7.24-2.29,9.78-5.84.88-1.22,1.66-2.64,2.37-4.29v24.56l-33.52-11.59,1.13.9c.27.22.49.48.63.77.32.65.28,1.38-.13,2.06-.2.33-.5.61-.91.86l-.44.28,31.97,11.05,1.13.39s.1.03.14.05v33.14l-42.72-20.27c-.24-.12-.4-.36-.4-.62v-13.12h-5.17v13.11c0,2.26,1.32,4.33,3.35,5.3l45.07,21.38.1.04c.13.06.25.11.39.16.5.18,1.01.29,1.55.33.5-.04,1-.15,1.51-.33.13-.05.25-.1.38-.16l45.17-21.43c2.04-.96,3.35-3.04,3.35-5.3v-13.11h-5.17v13.12ZM66.21,32.37c.38-3.55,1.23-7.03,2.52-10.35,1.56-4,3.32-8.54,7.74-12.13,3.3-2.68,8.86-5.39,13.83-5.39,2.24,0,4.13.56,5.63,1.65,2.01,1.47,3.92,4.29,3.69,6.84-.41,4.47-7.64,8.13-12.92,10.81-3.03,1.54-5.7,2.48-8.53,3.49-3.37,1.2-7.18,2.55-11.96,5.08ZM56,22.03c1.29,3.31,2.14,6.79,2.52,10.35-4.78-2.54-8.59-3.89-11.97-5.09-2.82-1-5.49-1.95-8.52-3.49-5.28-2.68-12.51-6.34-12.92-10.81-.23-2.55,1.68-5.37,3.69-6.84,1.5-1.1,3.39-1.65,5.63-1.65h0c4.97,0,10.52,2.71,13.83,5.39,4.42,3.6,6.19,8.13,7.74,12.13Z"/>
  <path d="M122.64,55.21c-1.87-1.95-7.44-2.14-22.19-1.72h0c-.21.01-5.24.29-6.58,2.09-.32.42-.42.89-.3,1.4.29,1.21,2.06,1.79,3.49,2.06,1.17.22,2.5.32,3.85.29.77,0,1.53-.04,2.26-.12,3.83-.42,13.26.39,15.03,1.12.64.27,1.43.45,2.2.45.67,0,1.33-.13,1.86-.46.71-.43,1.12-1.15,1.18-2.09.07-1.01.03-2.16-.79-3.02Z"/>
  <path d="M98.06,49.69c-.09.27-.13.68.23,1.13h0c.95,1.18,5.43,1.34,11.66,1.43,3.45.05,6.7.1,7.66.52.49.22,1.11.32,1.75.32,1.32,0,2.74-.46,3.43-1.41.56-.77.84-2.12-.98-4.16-3.87-4.31-17.39-.9-17.96-.76-.53.12-5.21,1.25-5.79,2.93Z"/>
  <path d="M105.22,66.58c-.41,0-3.82-.05-4.59,1.08-.14.2-.26.53-.07.98.45,1.09,3.56,2.08,7.89,3.35,2.39.7,4.64,1.36,5.23,1.85.54.45,1.4.73,2.22.73.59,0,1.16-.14,1.58-.47.5-.39,1.18-1.35.17-3.45-1.92-4.01-11.97-4.06-12.43-4.06Z"/>
  <path d="M102.56,59.86s-.3.03-.74.09c-.58.08-1.1.18-1.58.28-2.19.46-3.48,1.08-3.81,1.85-.15.35-.11.72.11,1.09.25.42.85.77,1.87,1.12.7.24,1.56.44,2.31.61,2.11.45,4.71.82,7.22,1.18,3.4.48,6.61.94,7.5,1.48.64.38,1.53.59,2.43.59,1.1,0,2.2-.31,2.85-1.01.65-.7,1.1-2-.45-4.25-3.28-4.77-17.11-3.1-17.73-3.03Z"/>
</svg>
<span v-if="jaSift">Subscription gift added</span>
<span v-else>Give the gift of a subscription to someone special!</span>
</div>
                <FormSection title="Your Information">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow> 
                    <DonorAddress />
                    <FormRow>
                      <FormLabel class="control-label">
                        <div style="padding-bottom:7px;">How did you hear about us?</div>
        
          <FormSelect field="custom.hearAboutUs" style="flex: 1; margin-right: 10px">
            <option :value="null">Select an option</option>
            <option value="instagram">Instagram</option>
            <option value="facebook">Facebook</option>
            <option value="x">X (Twitter)</option>
            <option value="whatsapp">WhatsApp</option>
            <option value="tiktok">TikTok</option>
            <option value="google">Google</option>
            <option value="print-magazine">Print Magazine</option>
            <option value="friend">Friend</option>
            <option value="family-member">Family Member</option>
            <option value="other">Other</option>
          </FormSelect>
        </FormLabel>
        </FormRow>
        <ErrorLabel field="custom.hearAboutUs" />
                </FormSection>  
                <JaGift /> 
                <FormRow>
                      <NewsletterSubscribe text="Sign me up for Jewish Action’s monthly newsletter" />
                </FormRow> 
                <br>     
                <FormSection title="Payment Details" last v-if="form.description != 'US: For Students'">
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>             
                </FormSection>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch } from "vue";
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  setup(props) {
    const { getValue, setValue, form } = usePaymentForm();

    const jaSift = computed(() => getValue("custom.isGift"));

    return {
      form,
      jaSift,
      getValue,
      setValue,
    }
  },
})
</script>
<style scoped lang="scss">

::v-deep h2 {
  font-size: 26px;
  padding-bottom: 20px;
  border-bottom: 1px solid #efefef;
  margin-bottom: 30px;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
label,
::v-deep label {
  font-size: .85em;
  color: #333;
}

.form-container.ou-donation-form.ja-ou-form{
    margin: 10px auto 0px !important;
    box-shadow: none !important;
}
.subscribe__btn {
    display: flex;
    background: #1DA1F2;
    color: white;
    margin-bottom: 20px;
    align-items: center;
    padding: 8px 12px;
    border-radius: 6px;
    font-weight: 600;
    gap: 7px;
    cursor:pointer;
    transition: all 0.3s ease-in-out;
    justify-content: center;
}
.subscribe__btn:hover{
      background: #004c7b;
    }
.subscribe__btn svg {
    height: 28px;
}
.subscribe__btn.checked{
      background: #f2f6fd;
    color: #595c5f;
    }

.subscribe__btn.checked svg {
    fill: #595c5f !important;
}
</style>

